import numeral from "numeral";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { cn, getPathURL } from "../../../utils/useFunctions";
import { PdfCard, PdfCardGray, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
} from "../styles/pdf.style";
import {
  options_education_rank,
  options_under_education,
} from "../../education/functions/options";
import { ImageMain } from "../../../components/img/Img.Main";

function ExpenseFuturePDF({
  page,
  datalist = [],
  isChildrenEducation = false,
  ischileFuture = false,
}) {
  const currentEdu = (currentEducation) =>
    options_education_rank?.find((item) => item?.value === currentEducation)
      ?.label;
  const targetEdu = (targetEducation) =>
    options_education_rank?.find((item) => item?.value === targetEducation)
      ?.label;
  const underEdu = (underEducatiion) =>
    options_under_education?.find((item) => item?.value === underEducatiion)
      ?.label;

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="แผนอนาคต"
        icon="/images/personal.svg"
        classNameIcon="w-[24px] h-[27px]"
      />
      {/* แผนอนาคต */}
      <PdfCard className={"flex flex-col space-y-3"} title={"รายจ่ายในอนาคต"}>
        {!isChildrenEducation &&
          datalist?.map((item, index) => {
            return (
              <PdfCardWhite
                key={index}
                className={cn("flex flex-col space-y-2 px-3")}
              >
                <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-left")}>
                  {item?.title}
                </div>
                <PdfLine />
                <div className="flex items-center space-x-2">
                  <div>
                    <img src={`/images/${item.icon}`} />
                  </div>
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    {item?.label}
                  </div>
                </div>
                <PdfCardGray className={cn("px-2")}>
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {"คาดการณ์ไว้อีก"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2"
                      )}
                    >
                      {`${
                        [
                          "car",
                          "children",
                          "travel",
                          "collection",
                          "ETCExpense",
                        ].includes(item?.type)
                          ? item?.year
                          : item?.interest_year
                      } ปี`}
                    </div>
                  </div>
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {ischileFuture ? "ค่าใช้จ่าย" : "เงินดาวน์"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2"
                      )}
                    >
                      {`${numeral(item?.down).format("0,0")} บาท`}
                    </div>
                  </div>
                  {["car"].includes(item?.type) && (
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {`ผลตอบแทน (ต่อปี)`}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${numeral(item?.invest_down_interest).format(
                          "0,0"
                        )} %`}
                      </div>
                    </div>
                  )}
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {"ออมเงิน/ลงทุน เพื่อท่องเที่ยว ได้ดอกเบี้ย (ต่อปี)"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2"
                      )}
                    >
                      {`${numeral(item?.sum_invest_five).format("0,0")} บาท`}
                    </div>
                  </div>
                  <div className="flex justify-between space-y-1">
                    {item?.type === "home" && (
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"มูลค่าบ้าน (บาท)"}
                      </div>
                    )}
                    {item?.type === "car" && (
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"มูลค่ารถ (บาท)"}
                      </div>
                    )}
                    {(item?.type === "home" || item?.type === "car") && (
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${numeral(item?.value).format("0,0")} บาท`}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-between space-y-1">
                    {item?.type === "home" && (
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"ดอกเบี้ยบ้าน (บาท)"}
                      </div>
                    )}
                    {item?.type === "car" && (
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"ต้องชำระงวดละ (บาท)"}
                      </div>
                    )}
                    {(item?.type === "home" || item?.type === "car") && (
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${numeral(item?.pay_per_year).format("0,0")} บาท`}
                      </div>
                    )}
                  </div>
                  {(item?.type === "home" || item?.type === "car") && (
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"ระยะเวลาที่ต้องการผ่อน"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${numeral(item?.period_year).format("0,0")} ปี`}
                      </div>
                    </div>
                  )}
                  {item?.type === "children" && (
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"เป้าหมายการศึกษา"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${
                          options_under_education?.find(
                            (item2) => item2?.value === item?.education_under
                          )?.label
                        } `}
                      </div>
                    </div>
                  )}
                </PdfCardGray>
              </PdfCardWhite>
            );
          })}
        {isChildrenEducation &&
          datalist?.map((item, index) => {

            return (
              <PdfCardWhite
                key={index}
                className={cn("flex flex-col space-y-2 px-3")}
              >
                <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-left")}>
                  {`บุตรคนที่ ${index + 1}`}
                </div>
                <PdfLine />
                <PdfCardGray className={cn(" flex px-2")}>
                  <div className="flex items-center space-x-2">
                    {item?.img === "" ? (
                        <div className=" rounded-[10px] w-[100px] h-[100px] overflow-hidden flex justify-center items-center">
                          <ImageMain
                            src={"../images/user_circle.png"}
                            className=" w-20 h-20 object-cover "
                          />
                        </div>
                      ) : (
                        <div className=" bg-white rounded-[10px] overflow-hidden w-[100px] h-[100px] flex justify-center items-center">
                          <ImageMain
                            src={`${getPathURL(item?.img)}`}
                            className="w-[100px] h-[100px] md:w-full md:h-full object-cover "
                          />
                        </div>
                      )}
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {item?.label}
                    </div>
                  </div>
                  <div className="px-2 w-full">
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"ชื่อ"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${item?.name}`}
                      </div>
                    </div>
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"ปีเกิด"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {/* {`${numeral(item?.year).format("0,0")}`} */}
                        {`${item?.year}`}
                      </div>
                    </div>
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"อายุ"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${numeral(item?.age).format("0,0")}`}
                      </div>
                    </div>
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"การศึกษาปัจจุบัน"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${currentEdu(item?.current_education)}`}
                      </div>
                    </div>
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"เป้าหมายการศึกษา"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${targetEdu(item?.target_education)}`}
                      </div>
                    </div>
                    <div className="flex justify-between space-y-1">
                      <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                        {"สังกัดการศึกษา"}
                      </div>
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                          "flex space-x-2"
                        )}
                      >
                        {`${underEdu(item?.under_education)}`}
                      </div>
                    </div>
                  </div>
                </PdfCardGray>
              </PdfCardWhite>
            );
          })}
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default ExpenseFuturePDF;
